import * as TYPES from './_store/types';
const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area'
};
export async function asyncData(store) {
    
    let nbrInfo = this.nbrInfo || {};
    const hjId = nbrInfo.hjId;
    const type = NBR_TYPE_NUM[nbrInfo.featureAreaType] || nbrInfo.type;
    return Promise.all([
        store[TYPES.GET_GEOGRAPHIC]({ hjId, type, locType: type || '', locStr: nbrInfo?.label || '' }),
        store[TYPES.GET_COUNTRYCONFIG](this.siteId),
        !this.hasSave && store[TYPES.GET_UP_DATA]()
    ])
}